// extracted by mini-css-extract-plugin
export default {"supportRibbon":"TenantDetail_supportRibbon__-o1a-"};